"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMessage = exports.insertNewMessage = exports.addStoredMessage = exports.setAutoSentMessage = exports.setTempUserId = exports.setAuthLoader = exports.setShowUserModal = exports.setAuthToken = exports.setStoredChatMessagesMeta = exports.setStoredMessages = exports.setSelectedVoice = exports.setMessagespeechToTextDisabled = exports.setCharacterImagesEnabled = exports.setMessageSpeech = exports.setStartVoiceAutoPlay = exports.setVoiceAutoPlay = exports.setTextStreaming = exports.setQuickSearch = exports.setIsPlaying = exports.setCharacterIsTyping = exports.setSyncLoading = exports.setImageLoading = exports.setIsLoading = exports.setCharacterSearch = exports.addSelectedCharacter = exports.setLastConversation = exports.setLastMessage = exports.setConversation = exports.setCharacterDetails = exports.setCharacter = exports.setFbUser = exports.setAppUser = exports.setRefreshMessages = exports.setImagePrompts = exports.setCharacterPrompts = exports.setPrompts = exports.setVoiceSpeed = exports.setIsDebug = exports.setCharacterTutor = exports.setGeneratedImageId = exports.setGeneratedImageSet = exports.setSystemMood = exports.setChatAction = exports.setUserAction = exports.setUser = exports.setCategory = exports.setDocumentCharacter = exports.clearDocument = exports.createTemporaryUser = exports.userOptionsSlice = void 0;
exports.resetUser = exports.resetAutoSentMessage = exports.resetLastMessage = exports.resetLastConversation = exports.resetCurrentConversation = exports.resetTextStreaming = exports.resetStoredMessages = exports.resetConversation = exports.resetCharacter = exports.patchMessage = exports.patchConversation = exports.patchCharacter = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const character_1 = require("../services/character");
const cache_1 = __importDefault(require("../helper/cache"));
const constants_1 = require("../common/constants");
const application_host_1 = require("../common/application-host");
const character_2 = require("./character");
const document_1 = require("./document");
;
const characterProfile = {
    id: "",
    characterId: "",
    characterName: "",
    background: "",
    createdAt: "",
    updatedAt: '',
    bio: "",
    reason: "",
    attitude: "",
    description: "",
    publishingInfo: "",
    keywords: [],
    relatedCharacters: [],
    extension: "",
    createdBy: "",
    createdByShareId: null,
    active: "Y",
    visibility: "PRIVATE",
    imageModelId: "",
    enableAutoGenImages: "Y",
    styleString: null,
    aspectRatio: "",
    voiceModel: "",
    jsonPath: null,
    summary: {
        title: "",
        images: [],
        fileIds: [],
        fileUrls: [],
        webUrl: "",
        youtubeUrl: "",
        summaryAudioUrl: "",
        fiveMinWrapAudioUrl: "",
        language: ""
    },
    primaryCategory: "",
    categories: []
};
const initialState = {
    categoryId: "", // selected catrgory
    characterProfile, // selected character
    selectedCharacters: [],
    search: "", // entered search text
    user: {},
    isLoading: false,
    IsCharacterTyping: false,
    isPlaying: false,
    debugMode: false,
    quickSearch: "",
    selectedVoice: constants_1.DEFAULT_VOICE,
    prompts: [],
    refreshMessages: false,
    mood: false,
    syncLoading: false,
    textStreaming: '',
    messageSpeech: false,
    messageSpeechToText: false,
    authToken: "",
    showModal: false,
    authLoader: false,
    generatedImageSet: [],
    tempUserId: 0,
};
exports.userOptionsSlice = (0, toolkit_1.createSlice)({
    name: "userOptionsSlice",
    initialState: initialState,
    reducers: {
        setCategory: (state, action) => {
            state.categoryId = action.payload;
        },
        setCharacter: (state, action) => {
            state.characterProfile = action.payload;
        },
        setCharacterDetails: (state, action) => {
            state.characterDetails = action.payload;
        },
        setPrompts: (state, action) => {
            state.prompts = action.payload;
        },
        setCharacterPrompts: (state, action) => {
            state.characterPrompts = action.payload;
        },
        setImagePrompts: (state, action) => {
            state.imagePrompts = action.payload;
        },
        setGeneratedImageSet: (state, action) => {
            state.generatedImageSet = action.payload;
        },
        setGeneratedImageId: (state, action) => {
            state.generatedImageId = action.payload;
        },
        addSelectedCharacter: (state, action) => {
            console.log("OLD state selectedCharacters:", state.selectedCharacters);
            state.selectedCharacters = {
                ...state.selectedCharacters, // previous selected characters
                ...action.payload, // newly selected characters
            };
        },
        setCharacterSearch: (state, action) => {
            state.search = action.payload;
        },
        setQuickSearch: (state, action) => {
            state.quickSearch = action.payload;
        },
        setSelectedVoice: (state, action) => {
            state.selectedVoice = action.payload;
        },
        setVoiceSpeed: (state, action) => {
            state.voiceSpeed = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setAppUser: (state, action) => {
            state.appUser = action.payload;
        },
        setFbUser: (state, action) => {
            state.fbUser = action.payload;
        },
        setConversation: (state, action) => {
            state.conversation = action.payload;
        },
        setLastMessage: (state, action) => {
            state.lastMessage = action.payload;
        },
        setLastConversation: (state, action) => {
            state.lastConversation = action.payload;
        },
        // setConversationLastMessageId: (state, action) => {
        //   if (state.conversation) {
        //     state.conversation.lastMessageId = action.payload;
        //   };
        // },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setImageLoading: (state, action) => {
            state.isImageLoading = action.payload;
        },
        setRefreshMessages: (state, action) => {
            state.refreshMessages = action.payload;
        },
        setCharacterIsTyping: (state, action) => {
            state.IsCharacterTyping = action.payload;
        },
        setIsPlaying: (state, action) => {
            state.isPlaying = action.payload;
        },
        setIsDebug: (state, action) => {
            state.debugMode = action.payload;
        },
        setSyncLoading: (state, action) => {
            state.syncLoading = action.payload;
        },
        setUserAction: (state, action) => {
            state.userAction = action.payload;
        },
        setChatAction: (state, action) => {
            state.chatAction = action.payload;
        },
        setSystemMood: (state, action) => {
            state.mood = action.payload;
        },
        setCharacterTutor: (state, action) => {
            state.tutor = action.payload;
        },
        setTextStreaming: (state, action) => {
            state.textStreaming = action.payload;
        },
        setMessageSpeech: (state, action) => {
            state.messageSpeech = action.payload;
        },
        setCharacterImagesEnabled: (state, action) => {
            state.characterImagesEnabled = action.payload;
        },
        setVoiceAutoPlay: (state, action) => {
            state.voiceAutoPlay = action.payload;
        },
        setStartVoiceAutoPlay: (state, action) => {
            state.startVoiceAutoPlay = action.payload;
        },
        setMessagespeechToTextDisabled: (state, action) => {
            state.messageSpeechToText = action.payload;
        },
        setStoredMessages: (state, action) => {
            state.storedMessages = action.payload;
        },
        setStoredChatMessagesMeta: (state, action) => {
            state.storedChatMessagesMeta = action.payload;
        },
        setAuthToken: (state, action) => {
            state.authToken = action.payload;
        },
        setShowUserModal: (state, action) => {
            state.showModal = action.payload;
        },
        setAuthLoader: (state, action) => {
            state.authLoader = action.payload;
        },
        setTempUserId: (state, action) => {
            state.tempUserId = action.payload;
        },
        setAutoSentMessage: (state, action) => {
            state.autoSentMessage = action.payload;
        },
        addStoredMessage: (state, action) => {
            state.storedMessages = [...state.storedMessages ?? [], action.payload];
        },
        insertNewMessage: (state, action) => {
            state.textStreaming = '';
            state.storedMessages = [...state.storedMessages ?? [], action.payload];
        },
        updateMessage: (state, action) => {
            const storedMessages = state.storedMessages;
            const updatedMessageIndex = state.storedMessages?.findIndex((message) => (message.id === action.payload.id));
            if (storedMessages && updatedMessageIndex && updatedMessageIndex !== -1) {
                state.storedMessages = [
                    ...storedMessages.slice(0, updatedMessageIndex),
                    action.payload,
                    ...storedMessages.slice(updatedMessageIndex + 1)
                ];
            }
            ;
        },
        patchCharacter(state, { payload }) {
            state.characterProfile = { ...state.characterProfile, ...payload };
        },
        patchConversation(state, { payload: { id, changes } }) {
            if (state.conversation?.id === id) {
                state.conversation = { ...state.conversation, ...changes };
            }
            ;
        },
        patchMessage: (state, action) => {
            const storedMessages = state.storedMessages;
            const updatedMessageIndex = state.storedMessages?.findIndex((message) => (message.id === action.payload.id));
            if (storedMessages && updatedMessageIndex !== undefined) {
                state.storedMessages = [
                    ...storedMessages.slice(0, updatedMessageIndex),
                    {
                        ...storedMessages[updatedMessageIndex],
                        ...action.payload,
                    },
                    ...storedMessages.slice(updatedMessageIndex + 1)
                ];
            }
            ;
        },
        resetCharacter: (state) => {
            state.characterProfile = characterProfile;
            state.conversation = initialState.conversation;
        },
        resetConversation: (state) => {
            state.conversation = initialState.conversation;
        },
        resetStoredMessages: (state) => {
            state.storedMessages = initialState.storedMessages;
        },
        resetTextStreaming: (state) => {
            state.textStreaming = initialState.textStreaming;
        },
        resetCurrentConversation: (state) => {
            state.characterProfile = characterProfile;
            state.textStreaming = "";
            state.conversation = initialState.conversation;
        },
        resetLastConversation: (state) => {
            state.lastConversation = initialState.lastConversation;
        },
        resetLastMessage: (state) => {
            state.lastMessage = initialState.lastMessage;
        },
        resetAutoSentMessage: (state) => {
            state.autoSentMessage = initialState.autoSentMessage;
        },
        resetUser: () => initialState,
    },
    extraReducers(builder) {
        builder.addCase(exports.createTemporaryUser.fulfilled, (state, action) => {
            state.appUser = action.payload;
        });
        builder.addCase(character_2.createPermanentUserAsync.fulfilled, (state, action) => {
            state.appUser = action.payload.data;
        });
    },
});
exports.createTemporaryUser = (0, toolkit_1.createAsyncThunk)('getUserOptions/setAppUser', () => ((0, character_1.createNewSyncUser)().then(async (result) => {
    const newUser = {
        ...result.data,
        env: application_host_1.ENV_TYPE,
    };
    await cache_1.default.setItem(`appUser_${application_host_1.ENV_TYPE}`, newUser);
    return newUser;
})));
exports.clearDocument = (0, toolkit_1.createAsyncThunk)('getUserOptions/clearDocument', (_, { dispatch }) => {
    dispatch((0, document_1.resetDocumentJson)());
    dispatch((0, document_1.resetSelectedFileIds)());
});
exports.setDocumentCharacter = (0, toolkit_1.createAsyncThunk)('getUserOptions/setDocumentCharacter', (character, { dispatch, getState }) => {
    if (!getState().documents.documentJson) {
        dispatch((0, exports.setCharacter)(character));
        dispatch((0, exports.setConversation)(character.conversation));
    }
    ;
});
_a = exports.userOptionsSlice.actions, exports.setCategory = _a.setCategory, exports.setUser = _a.setUser, exports.setUserAction = _a.setUserAction, exports.setChatAction = _a.setChatAction, exports.setSystemMood = _a.setSystemMood, exports.setGeneratedImageSet = _a.setGeneratedImageSet, exports.setGeneratedImageId = _a.setGeneratedImageId, exports.setCharacterTutor = _a.setCharacterTutor, exports.setIsDebug = _a.setIsDebug, exports.setVoiceSpeed = _a.setVoiceSpeed, exports.setPrompts = _a.setPrompts, exports.setCharacterPrompts = _a.setCharacterPrompts, exports.setImagePrompts = _a.setImagePrompts, exports.setRefreshMessages = _a.setRefreshMessages, exports.setAppUser = _a.setAppUser, exports.setFbUser = _a.setFbUser, exports.setCharacter = _a.setCharacter, exports.setCharacterDetails = _a.setCharacterDetails, exports.setConversation = _a.setConversation, exports.setLastMessage = _a.setLastMessage, exports.setLastConversation = _a.setLastConversation, 
// setConversationLastMessageId,
exports.addSelectedCharacter = _a.addSelectedCharacter, exports.setCharacterSearch = _a.setCharacterSearch, exports.setIsLoading = _a.setIsLoading, exports.setImageLoading = _a.setImageLoading, exports.setSyncLoading = _a.setSyncLoading, exports.setCharacterIsTyping = _a.setCharacterIsTyping, exports.setIsPlaying = _a.setIsPlaying, exports.setQuickSearch = _a.setQuickSearch, exports.setTextStreaming = _a.setTextStreaming, exports.setVoiceAutoPlay = _a.setVoiceAutoPlay, exports.setStartVoiceAutoPlay = _a.setStartVoiceAutoPlay, exports.setMessageSpeech = _a.setMessageSpeech, exports.setCharacterImagesEnabled = _a.setCharacterImagesEnabled, exports.setMessagespeechToTextDisabled = _a.setMessagespeechToTextDisabled, exports.setSelectedVoice = _a.setSelectedVoice, exports.setStoredMessages = _a.setStoredMessages, exports.setStoredChatMessagesMeta = _a.setStoredChatMessagesMeta, exports.setAuthToken = _a.setAuthToken, exports.setShowUserModal = _a.setShowUserModal, exports.setAuthLoader = _a.setAuthLoader, exports.setTempUserId = _a.setTempUserId, exports.setAutoSentMessage = _a.setAutoSentMessage, exports.addStoredMessage = _a.addStoredMessage, exports.insertNewMessage = _a.insertNewMessage, exports.updateMessage = _a.updateMessage, exports.patchCharacter = _a.patchCharacter, exports.patchConversation = _a.patchConversation, exports.patchMessage = _a.patchMessage, exports.resetCharacter = _a.resetCharacter, exports.resetConversation = _a.resetConversation, exports.resetStoredMessages = _a.resetStoredMessages, exports.resetTextStreaming = _a.resetTextStreaming, exports.resetCurrentConversation = _a.resetCurrentConversation, exports.resetLastConversation = _a.resetLastConversation, exports.resetLastMessage = _a.resetLastMessage, exports.resetAutoSentMessage = _a.resetAutoSentMessage, exports.resetUser = _a.resetUser;
